import { render, staticRenderFns } from "./BrowserWarning.vue?vue&type=template&id=59e7a50b"
import script from "./BrowserWarning.vue?vue&type=script&lang=ts"
export * from "./BrowserWarning.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../nuxt-app/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports